import $ from 'jquery'

/**
 * Adapter for JQuery's get method
 * @returns {void}
 */
export default function (...args) {
  return $.get(...args)
}
